import { render, staticRenderFns } from "./infoPage.vue?vue&type=template&id=405c6a2c&"
import script from "./infoPage.vue?vue&type=script&lang=js&"
export * from "./infoPage.vue?vue&type=script&lang=js&"
import style0 from "./infoPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports